import { KEYCLOAK_HOST } from './environment'

import Keycloak from 'keycloak-js'

// @ts-ignore
export const keycloak = new Keycloak({
  url: KEYCLOAK_HOST,
  realm: 'TomraConnectUsers',
  clientId: 'barcode-manager-ui'
})

